import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './View.module.css';
import ViewActions from './components/ViewActions';
import ViewBody from './components/ViewBody';
import ViewHeader from './components/ViewHeader';

const bindClasses = classNameBind.bind(styles);

const View = ({
  fullWidth,
  children,
  fullHeight,
  heightAuto,
  overflowTopElement,
}) => (
  <div
    className={bindClasses('wrapper', { fullWidth, fullHeight, heightAuto, overflowTopElement: !!overflowTopElement })}
    data-ppuc-id="View"
  >
    {overflowTopElement
      ? (
        <React.Fragment>
          {overflowTopElement}
          <div className={bindClasses('children-with-scroll')}>
            {children}
          </div>
        </React.Fragment>
      )
      : children}
  </div>
);

View.defaultProps = {
  fullWidth: false,
  fullHeight: false,
  heightAuto: false,
  children: null,
  overflowTopElement: null,
};

View.Action = ViewActions;
View.Header = ViewHeader;
View.Body = ViewBody;

export default View;
